<template>
    <div class="progress">
        <div
            class="progress__bar"
            :style="{ width: grossLoadPercentage + '%' }"
        >
            <span>{{ loadPercentage }}%</span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        progress: {
            type: Number,
            default: 0,
        },
        total: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        loadPercentage() {
            return Math.round((this.progress / this.total) * 100) || 0;
        },
        grossLoadPercentage() {
            return this.loadPercentage !== 0 ? this.loadPercentage + 7 : 0;
        },
    },
};
</script>

<style lang="scss" scoped>
.progress {
    font-size: 1rem;
    height: 2.5em;
    border: 2px solid #22354a;
    border-radius: 1.5em;
    overflow: hidden;
    box-shadow: inset 0 0 0 1px #22354a;
}

.progress__bar {
    position: relative;
    float: left;
    min-width: rem(80);
    height: 100%;
    background-image: repeating-linear-gradient(
        315deg,
        #12566b,
        #12566b 7px,
        #22354a 0,
        #22354a 14px
    );
    background-position: 0 0;
    background-size: 20px 40px;
    background-repeat: repeat;
    color: #fff;
    font-size: 1em;
    display: flex;
    align-items: center;
    justify-content: center;

    transition: all ease-in-out 0.15s;
    animation: loading 1s linear infinite;

    &::after {
        content: '';
        position: absolute;
        top: 1px;
        bottom: 1px;
        right: 0;
        display: block;
        width: 0;
        height: 0;
        border-bottom: calc(2.5em - 6px) solid #fff;
        border-left: calc(2.5em - 6px) solid transparent;
    }

    span {
        margin-right: em(10);
    }
}

@keyframes loading {
    from {
        background-position: 0 0;
    }

    to {
        background-position: 2.95rem 0;
    }
}
</style>
